var _style, _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKayak(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1920",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .st0{fill:#fff}.st1{fill:none;stroke:#231f20;stroke-width:50;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1098.7 748.4c-2.6-25.2-5.5-49.6-8.6-73-4.9-36.7-10.6-71.1-16.6-103.4-.9-4.7-1.8-9.3-2.7-13.8-6-30.8-12.4-59.4-19-86C1009.4 301.2 960 217 960 217s-49.4 84.2-91.8 255.3c-6.6 26.6-13 55.2-19 86l-2.7 13.8c-6.1 32.2-11.7 66.7-16.6 103.4-12.8 94.5-21.2 203.9-21.2 328.2 0 61.9 3 120.2 8.1 174.7C848.3 1512 960 1703.1 960 1703.1s151.2-258.5 151.2-699.4c0-93.6-4.7-178.6-12.5-255.3zM960 1253.7c-36.6 0-67.8-72-79.4-172.6-3.1-27.3-4.9-56.6-4.9-87.2 0-143.5 37.7-198.6 84.3-198.6 27.2 0 51.3 18.8 66.7 62.9 11 31.5 17.6 75.9 17.6 135.7 0 143.5-37.8 259.8-84.3 259.8z",
    id: "Layer_2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M727.5 1314.7c-11.9-7.8-25.4-11.6-38.6-11.6-23 0-45.6 11.2-59.1 31.9l-107 163.3c-7.4 11.3-4.2 26.5 7 33.9l77.2 50.6c11.3 7.4 26.5 4.2 33.9-7.1l107-163.3c21.3-32.5 12.2-76.3-20.4-97.7zm662.7-926.9l-77.2-50.6c-11.3-7.4-26.5-4.2-33.9 7l-107 163.3c-21.4 32.6-12.3 76.4 20.3 97.7 11.9 7.8 25.4 11.6 38.6 11.6 23 0 45.6-11.2 59.1-31.9l107-163.3c7.5-11.3 4.3-26.4-6.9-33.8z",
    id: "Layer_4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1044.3 993.9c0 143.5-37.7 259.8-84.3 259.8-36.6 0-67.8-72-79.4-172.6-3.1-27.3-4.9-56.6-4.9-87.2 0-143.5 37.7-198.6 84.3-198.6 27.2 0 51.3 18.8 66.7 62.9 11 31.5 17.6 75.9 17.6 135.7z",
    id: "Layer_5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "STROKES"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1111.2 1003.7c0 440.9-151.2 699.4-151.2 699.4s-151.2-258.5-151.2-699.4c0-124.3 8.4-233.7 21.1-328.2 5-36.7 10.6-71.1 16.6-103.4.9-4.7 1.8-9.3 2.7-13.8 6-30.8 12.4-59.4 19-86C910.6 301.2 960 217 960 217s49.4 84.2 91.7 255.3c6.6 26.6 13 55.2 19 86l2.7 13.8c6.1 32.2 11.7 66.7 16.6 103.4 12.8 94.5 21.2 203.8 21.2 328.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1044.3 993.9c0 143.5-37.7 259.8-84.3 259.8s-84.3-116.3-84.3-259.8 37.7-198.6 84.3-198.6 84.3 55.1 84.3 198.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M846.6 572L960 620.2l130 55.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M830 675.4l130-55.2 113.4-48.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M868.3 472.2l91.7 39 110.8 47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1051.7 472.2l-91.7 39-110.8 47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1192.5 605.3c-32.6-21.4-41.7-65.1-20.3-97.7l107-163.3c7.4-11.3 22.6-14.5 33.9-7.1l77.2 50.6c11.3 7.4 14.5 22.6 7.1 33.9l-107 163.3c-21.6 32.5-65.3 41.6-97.9 20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M727.5 1314.7c32.6 21.4 41.7 65.1 20.3 97.7l-107 163.3c-7.4 11.3-22.6 14.5-33.9 7.1l-77.2-50.6c-11.3-7.4-14.5-22.6-7.1-33.9l107-163.3c21.6-32.5 65.3-41.6 97.9-20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1192.5 605.3l-465 709.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKayak);
export default __webpack_public_path__ + "static/media/kayak.fc9d43febed45fdb08687b2e812b17f7.svg";
export { ForwardRef as ReactComponent };